import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {faCaretDown, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {AuthService} from "../../../../login/data-access/auth.service";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface OnInit {
  ngOnInit(): void
}

interface response {
  accepted: boolean,
  display_name: string,
  email: string,
  response_date: string,
  response_time: string,
  student_id: number | null,
  username: string
}

@Component({
    selector: 'agreementResponseList',
    templateUrl: './agreementResponseList.html',
    standalone: false
})
export class AgreementResponseList implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) {
  }

  responses: response[] = [];

  title: string = '';
  // NOTE: 24 is the default
  responsesPerPage = 25;
  // NOTE: 1 is the default and min
  pageNumber = 1;
  maxPage = 1;
  faCaretDown = faCaretDown
  faChevronLeft = faChevronLeft
  faChevronRight = faChevronRight
  token = document.cookie.split("; ").find((row) => row.startsWith("token="))?.split("=")[1];
  id: number = 0
  breadcrumbNav: BreadcrumbNavigation[] = [{
    text: 'User Agreement Management',
    route: 'dashboard/AgreementManagement/list'
  }]

  ngOnInit() {
    const select: HTMLInputElement = document.getElementById('select') as HTMLInputElement;
    // TODO: on refresh HTMLInput is null because ngOnIt is happening before the element loads, needs state management
    let value: string = '25';
    if(select !== null) {
      value = select.value
    }
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.title = params['title'];
      this.authService.getResponsesPage(params['id'], this.pageNumber - 1, value).subscribe((response) => {
        this.interpolateJSON(response)
      })
    })
  }

  agreementManagement() {
    this.router.navigate(['dashboard/AgreementManagement/list']);
  }

  incrementPage() {
    const select: HTMLInputElement = document.getElementById('select') as HTMLInputElement;
    this.pageNumber += 1;
    this.authService.getResponsesPage(this.id, this.pageNumber - 1, select.value).subscribe((response) => {
      this.interpolateJSON(response)
    })
  }

  decrementPage() {
    const select: HTMLInputElement = document.getElementById('select') as HTMLInputElement;
    if(this.pageNumber !== 1) {
      this.pageNumber -= 1
      this.authService.getResponsesPage(this.id, this.pageNumber - 1, select.value).subscribe((response) => {
        this.interpolateJSON(response)
      })
    }
  }

  perPage() {
    const select: HTMLInputElement = document.getElementById('select') as HTMLInputElement;
    this.authService.getResponsesPage(this.id, this.pageNumber - 1, select.value).subscribe((response) => {
      this.interpolateJSON(response)
    })
  }

  interpolateJSON(json: any) {
    this.pageNumber = json.result.page + 1
    this.maxPage = Math.floor(json.result.totalcount / json.result.limit)  + 1
    this.responses = json.result.items
    this.responses.forEach(response => {
      const date = new Date(response.response_date);
      response.response_date = date.toLocaleDateString();
      response.response_time = date.toLocaleTimeString();
    })
  }
}
